import { COLOR1, COLOR4, COLOR5, COLOR6, RADIO_COLOR } from '../../../constants';

export const BeneficiaryCompStyles = {
  beneficiaryText1: {
    font: 'normal normal 700 24px/100% TTNormsProBold',
    letterSpacing: '0px',
    color: COLOR1,
    textAlign: 'left',
  },

  beneficiaryText2: {
    font: 'normal normal 700 20px/20px TTNormsProBold',
    letterSpacing: '0px',
    color: '#141414',
    textAlign: 'center',
  },

  beneficiaryText3: {
    font: 'normal normal 400 16px/20px Arial',
    letterSpacing: '0px',
    color: COLOR6,
    textAlign: 'center',
  },

  beneficiaryAddButton: {
    background: `${RADIO_COLOR} 0% 0% no-repeat padding-box`,
    color: COLOR4,
    textAlign: 'center',
    letterSpacing: '0px',
    font: 'normal normal 700 16px/20px Arial',
    width: 'fit-content',
    borderRadius: '56px',
    padding: '10px 50px',
    gap: '8px',
    opacity: 1,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: RADIO_COLOR,
    },
    '&:focus': {
      outline: `2px solid ${RADIO_COLOR}`,
      outlineOffset: `2px`,
    },
  },

  cardText: {
    font: 'normal normal 700 16px/100% Arial',
    letterSpacing: '0px',
    color: COLOR1,
    textAlign: 'center',
    padding: '0px 10px',
  },

  toggleText: {
    font: 'normal normal 400 16px/100% Arial',
    letterSpacing: '0px',
    color: COLOR1,
    textAlign: 'start',
  },

  caeSubText: {
    font: 'normal normal 400 14px/18px Arial',
    letterSpacing: '0px',
    color: COLOR6,
    textAlign: 'start',
  },

  caeCard: {
    font: 'normal normal 400 16px/20px Arial',
    letterSpacing: '0px',
    color: '#141414',
    textAlign: 'center',
  },

  beneficiaryMainContainer: {
    width: '100%',
    marginTop: '20px',
    paddingTop: '20px',
    borderTop: '1px solid #E6E6E6',
  },

  beneficiarySubContainer1: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '24px',
  },

  subHeadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
  },

  inputContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    justifyContent: 'center',
    gap: '20px',
  },

  cardContainer: {
    display: 'flex',
    flexWrap: 'nowrap',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'start',
    gap: '25px',
    marginTop: '12px',
  },

  cardContent: {
    borderRadius: '6px',
    backgroundColor: '#FFFFFF',
    border: `1px solid #E6E6E6`,
    color: COLOR1,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    height: '150px',
    width: '100%',
    maxWidth: '150px',
    textAlign: 'center',
    gap: '18px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },

  toggleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'start',
    flexWrap: 'nowrap',
    marginTop: '20px',
    gap: '12px',
  },

  caeContainer: {
    margin: '20px 0px',
    paddingBottom: '20px',
    borderBottom: '1px solid #E6E6E6',
  },

  caeSubHeading: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'start',
    justifyContent: 'start',
    flexWrap: 'nowrap',
    margin: '12px 0px 20px 0px',
    gap: '4px',
  },

  emailCardContainer: {
    display: 'flex',
    flexWrap: 'nowrap',
    gap: '10px',
    marginTop: '8px',
    alignItems: 'stretch',
  },

  emailCard: {
    borderRadius: '6px',
    backgroundColor: '#FFFFFF',
    border: `1px solid #D0D0D0`,
    color: '#141414',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    height: 'auto',
    width: '100%',
    padding: '16px 0px',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
  },

  errorMessage: {
    font: 'normal normal normal 14px/16px Arial',
    letterSpacing: '0.1px',
    color: '#FD0000',
    opacity: 1,
    position: 'relative',
    top: '3px',
    display: 'block',
  },

  etbContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    justifyContent: 'center',
    gap: '20px',
    marginTop: '20px',
    paddingTop: '20px',
    borderTop: '1px solid #E6E6E6',
    width: '100%',
  },

  etbSubHeadingGrid: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    justifyContent: 'center',
    gap: '8px',
  },

  buttonGroup: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'end',
    justifyContent: 'start',
    gap: '0px',
    width: '100%',
  },

  activeButton: {
    width: '100%',
    maxWidth: '255px',
    padding: '12px 0px',
    font: 'normal normal normal 700 14px/20px Arial',
    letterSpacing: '0px',
    textAlign: 'center',
    opacity: 1,
    textTransform: 'none',
    color: COLOR5,
    border: 'none',
    borderBottom: '2px solid #661C69',
    borderRadius: '0px',
    '&:hover': {
      backgroundColor: COLOR4,
      color: COLOR5,
    },
    '&:focus': {
      backgroundColor: COLOR4,
      color: COLOR5,
    },
    '&:active': {
      backgroundColor: COLOR4,
      color: COLOR5,
    },
    '&.Mui-selected': {
      backgroundColor: COLOR4,
      color: COLOR5,
    },
    '&.Mui-selected:hover': {
      backgroundColor: COLOR4,
      color: COLOR5,
    },
    '&.Mui-selected:active': {
      backgroundColor: COLOR4,
      color: COLOR5,
    },
  },

  passiveButton: {
    width: '100%',
    maxWidth: '255px',
    padding: '12px 0px',
    font: 'normal normal normal 700 14px/20px Arial',
    letterSpacing: '0px',
    textAlign: 'center',
    opacity: 1,
    textTransform: 'none',
    color: COLOR1,
    border: 'none',
    borderBottom: '1px solid #E6E6E6',
    borderRadius: '0px',
    '&:hover': {
      backgroundColor: COLOR4,
      color: COLOR1,
    },
    '&:focus': {
      backgroundColor: COLOR4,
      color: COLOR1,
    },
    '&:active': {
      backgroundColor: COLOR4,
      color: COLOR1,
    },
    '&.Mui-selected': {
      backgroundColor: COLOR4,
      color: COLOR1,
    },
    '&.Mui-selected:hover': {
      backgroundColor: COLOR4,
      color: COLOR1,
    },
    '&.Mui-selected:active': {
      backgroundColor: COLOR4,
      color: COLOR1,
    },
  },

  amountText: {
    font: 'normal normal 700 16px/20px Arial',
    letterSpacing: '0px',
    color: '#727578',
    textAlign: 'left',
  },

  infoContainer: {
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'start',
    gap: '8px',
  },
  documentUploadContainer: {
    display: 'flex',
    flexDirection: 'row',
    '@media (max-width:1160px)': {
      display: 'flex',
      flexDirection: 'column',
    },
  },
};
